// Export Center Page
import React, { useState } from 'react';
import { useAdminTranslation } from '../utils/i18nContext';
import { adminApi } from '../utils/api';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, FileText, Database } from 'lucide-react';
import { toast } from 'sonner';

const ExportCenter = () => {
  const { t } = useAdminTranslation();
  const [loading, setLoading] = useState(false);

  const handleExport = async (format) => {
    setLoading(true);
    try {
      await adminApi.exportUsers(format);
      toast.success(`${t('export')} ${t('success')}`);
    } catch (error) {
      toast.error(`${t('export')} ${t('error')}: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const exportOptions = [
    {
      title: t('export_users'),
      description: 'Download all user data',
      formats: ['csv', 'json'],
      icon: Database,
      color: 'text-cyan-400'
    }
  ];

  return (
    <div className="space-y-6">
      <h2 className="text-3xl font-bold text-white">{t('export_data')}</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {exportOptions.map((option) => {
          const Icon = option.icon;
          return (
            <Card key={option.title} className="bg-[#0A0A0A] border-white/10">
              <CardHeader>
                <CardTitle className="flex items-center gap-3 text-white">
                  <Icon className={`w-6 h-6 ${option.color}`} />
                  {option.title}
                </CardTitle>
                <p className="text-sm text-gray-400">{option.description}</p>
              </CardHeader>
              <CardContent>
                <div className="flex gap-2">
                  {option.formats.map((format) => (
                    <Button
                      key={format}
                      onClick={() => handleExport(format)}
                      disabled={loading}
                      className="bg-gradient-to-r from-cyan-500 to-purple-500 hover:from-cyan-600 hover:to-purple-600"
                    >
                      <Download className="w-4 h-4 mr-2" />
                      {format.toUpperCase()}
                    </Button>
                  ))}
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="bg-yellow-500/5 border-yellow-500/20">
        <CardContent className="pt-6">
          <div className="flex items-start gap-3">
            <FileText className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-sm text-gray-300">
                <strong className="text-yellow-300">Note:</strong> All exports are logged in the audit trail.
                Downloaded files contain sensitive data - handle with care.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ExportCenter;
